import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    makeStyles,
} from '@material-ui/core';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { FormatoImpresionInformeOftalmo } from './FormatoImpresionInformeOftalmo';

const useStyles = makeStyles((theme) => ({
    background: {
        backgroundColor: theme.palette.grey[50],
    },
    title: {
        color: theme.palette.primary.main,
    },
}));

export const InformeOftalmoItem = (props) => {
    // const dispatch = useDispatch();
    const { informe } = props;
    const [open, setOpen] = useState(false);
    const classes = useStyles();

    const onSubmitHandler = () => { };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    // const envioPorCorreo = () => {
    //     dispatch(enviarPDFInforme(informe.id));
    // };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handlePrintRow = () => {
        handlePrint();
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent className={classes.background}>
                    <FormatoImpresionInformeOftalmo
                        informe={informe}
                        handleClose={handleClose}
                        handlePrintRow={handlePrintRow}
                        componentRef={componentRef}
                        modal
                    />
                </DialogContent>
            </Dialog>
            <Dialog fullWidth maxWidth="md" open={props.open} onClose={props.close}>
                <DialogTitle>{props.titulo}</DialogTitle>
                <DialogContent>
                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ paddingLeft: 16 }}
                            >
                                <TextValidator
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={12}
                                    //label="Ingrese Evolucion"
                                    name="informe"
                                    value={informe.informe}
                                    //validators={["required"]}
                                    //errorMessages={["Este campo es requerido"]}
                                    disabled={props.disabled}
                                //onChange={onChangeTextAreaHandler}
                                //error={error}
                                //helperText={error && "Este campo es requerido"}
                                />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                margin: '1rem 0',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={props.close}>
                                Cancelar
                            </Button>
                            {/* <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={envioPorCorreo}
                            >
                                Enviar al correo
                            </Button> */}
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={handleClickOpen}
                            >
                                Imprimir
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};
